import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import config from 'src/config';
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig';
import api from 'src/actions/api';

class LoginHeader extends React.Component {
  render() {
    let { pageConfig, loading, toggleSignup, toggleContacts, signupState } = this.props;
    return (
      <div class="content-header white  box-shadow-0" id="content-header">
        <div class="login-content-header-container container">
          <div class="row">
            <div class="col">
              <div class="plane">
                <img src={pageConfig.plane} alt="" />
              </div>
              <div class="logo">
                {pageConfig.logo.image && <img src={pageConfig.logo.image} alt="" />}
                {pageConfig.logo.text && <span class="logo-text">{pageConfig.logo.text}</span>}
              </div>
            </div>
            <div class="col co__top-menu">
              {pageConfig.newHome && (
                <ul>
                  <li>
                    <a href="/app/terms" target="_blank">
                      Terms
                    </a>
                  </li>
                  <li>
                    <a href="/app/privacy" target="_blank">
                      Privacy
                    </a>
                  </li>
                  <li>
                    <a onClick={toggleContacts}>Contact</a>
                  </li>
                </ul>
              )}
              {!loading && (
                <button class="btn btn-sm primary pull-right btn-toggle-signup" onClick={toggleSignup}>
                  {signupState ? 'Sign in' : 'Sign up'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  function(state) {
    return {
      logged: !!state.session.user,
      user: state.session.user,
      lastPage: state.session.lastPage,
      login: state.api.auth_login || state.api.initial,
      signup: state.api.auth_signup || state.api.initial,
      autologin: state.api.auth_autologin || state.api.initial,
      sid: state.api.auth_sid || state.api.initial,
      logback: state.api.auth_logback || state.api.initial,
      keepSid: state.session.keepSid,
    };
  },
  { api }
)(LoginHeader);
